import apiPaths from '../api-paths';

export default {
  list() {
    return axios.get(`${ apiPaths.API }/roles`);
  },
};
